






























































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import IPost from '@/components/icons/IPost.vue'
import IComment from '@/components/icons/IComment.vue'
import ITrash from '@/components/icons/ITrash.vue'
import IBranch from '@/components/icons/IBranch.vue'
import IEdit from '@/components/icons/IEdit.vue'
import ICheck from '@/components/icons/ICheck.vue'
import IClose from '@/components/icons/IClose.vue'
import draggable from 'vuedraggable'
import Tooltip from '@/components/UI/Tooltip.vue';
import IProduct from '@/components/icons/IProduct.vue'

const workspace = namespace('workspace')
const products = namespace('products')

@Component({
  name: "SurveyQuestion",
  components: {
    SurveyQuestionChildren:() => import('@/components/beta/Settings/Surveys/SurveyQuestionChildren.vue'),
    'i-post': IPost,
    'i-comment': IComment,
    'i-trash': ITrash,
    'i-branch': IBranch,
    'i-edit': IEdit,
    'i-check': ICheck,
    'i-close': IClose,
    draggable,
    Tooltip,
    IProduct,
  }
})
export default class SurveyQuestion extends Vue {
  @workspace.Getter('getPlan') protected getPlan: any
  @products.Getter('products') protected products: any

  @Prop({ type: Object, default: {} }) protected question!: any;
  @Prop({ type: Boolean, default: false }) protected isEdit!: boolean;
  @Prop({ type: String, default: ''}) protected currentQuestionId!: string;
  @Prop({ type: Boolean, default: false }) protected isChangeQuestion!: boolean;

  localFun(val:any){
   if(val.specify == 'text') return this.$t('surveys.form.textAnswer')
   if(val.specify == 'single' && val.type =='select') return this.$t('surveys.form.oneAnswer')
   if(val.specify == 'multi' && val.type =='select') return this.$t('surveys.form.someAnswer')
  }

    drag:boolean = false
    currentAnswer:any = []

    get questionChilds() {
        let array:any = []
        this.question.answers.forEach((answer:any) => {
            if(answer.includeQuestions.length) {
                answer.includeQuestions.forEach((includeQuestion:any) => {
                    if(typeof(includeQuestion) != 'string') {
                        array.push(includeQuestion)
                    }
                })
            }
        })
        return array
    }

    get otherAnswer() {
        return this.question.answers.filter((a:any) => {
            return a.type == 'free_text_input' || a.type == 'free_number_input'
        })
    }

  addAnswers(question:any) {
    this.$emit('addAnswers', question)
  }


  deleteIncludeQuestion(answer:any, includeQuestion:any) {
    this.$emit('deleteIncludeQuestion', answer, includeQuestion)
  }

  deleteQuestion(question:any) {
    this.$emit('deleteQuestion', question)
  }

  deleteAnswer(question:any, answer:any) {
    this.$emit('deleteAnswer', question, answer)
  }

  editAnswer(answer:any) {
    this.currentAnswer = {...answer}
    this.$emit('editAnswer', answer, this.question)
  }

  changeAnswer(answer:any) {
    answer.isEdit = false
    this.$emit('changeAnswer', answer, this.currentAnswer)
  }

  cancelEditAnswer(answer:any) {
    this.$emit('cancelEditAnswer', answer)
  }
  
  changeIncludes(answer:any, title:string, question:any) {
    this.$emit('changeIncludes', answer, title, question)
  }

  chooseQuestion(question:any) {
    this.$emit('chooseQuestion', question)
  }

}
